import axios from "axios";

// Use the same origin the page is loaded from to avoid CORS/cookie issues
// across multiple Emergent preview aliases. Falls back to env var for SSR.
const ORIGIN = typeof window !== "undefined" && window.location?.origin
  ? window.location.origin
  : process.env.REACT_APP_BACKEND_URL;

export const API = `${ORIGIN}/api`;

const api = axios.create({
  baseURL: API,
  withCredentials: true,
  headers: { "Content-Type": "application/json" },
});

export function formatApiError(detail) {
  if (detail == null) return "Something went wrong.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).join(" ");
  if (typeof detail === "object" && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export const fmtJMD = (amount) =>
  `JMD $${Number(amount || 0).toLocaleString("en-US", { minimumFractionDigits: 0, maximumFractionDigits: 2 })}`;

export default api;
